const NOTRANSLATE_CLASS = "notranslate";

function ensureMetaNotranslate(name) {
  if (typeof document === "undefined") {
    return;
  }

  const selector = `meta[name="${name}"]`;
  if (document.head.querySelector(selector)) {
    return;
  }

  const meta = document.createElement("meta");
  meta.setAttribute("name", name);
  meta.setAttribute("content", "notranslate");
  document.head.appendChild(meta);
}

function ensureElementNotranslate(element) {
  if (!element) {
    return;
  }

  element.setAttribute("translate", "no");
  element.classList.add(NOTRANSLATE_CLASS);
}

function ensureTranslationProtection() {
  if (typeof document === "undefined") {
    return;
  }

  ensureMetaNotranslate("google");
  ensureMetaNotranslate("googlebot");

  ensureElementNotranslate(document.documentElement);
  ensureElementNotranslate(document.body);
  ensureElementNotranslate(document.getElementById("root"));
}

export function setupTranslationGuard() {
  if (typeof document === "undefined") {
    return;
  }

  ensureTranslationProtection();

  const htmlBodyObserver = new MutationObserver(() => {
    ensureTranslationProtection();
  });

  htmlBodyObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["translate", "class", "lang"],
  });

  if (document.body) {
    htmlBodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["translate", "class"],
    });
  }

  const headObserver = new MutationObserver(() => {
    ensureMetaNotranslate("google");
    ensureMetaNotranslate("googlebot");
  });

  if (document.head) {
    headObserver.observe(document.head, {
      childList: true,
    });
  }
}
